import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { listRemovalError } from "@planzone/dto";

const initialState: State = [];

function handleRequest(
  state: State,
  list: Boundaries["removeList"]["request"],
): State {
  return [
    ...state,
    { list, request: setRequestStateToPending(), error: listRemovalError },
  ];
}

function handleSuccess(
  state: State,
  list: Boundaries["removeList"]["success"],
): State {
  return state.map((item) =>
    item.list.uuid === list.uuid
      ? { list, request: setRequestStateToSuccess(), error: listRemovalError }
      : item,
  );
}

function handleFailure(
  state: State,
  { list, error }: Boundaries["removeList"]["failure"],
): State {
  return state.map((item) =>
    item.list.uuid === list.uuid
      ? { list, request: setRequestStateToFailure(), error }
      : item,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeListRequested]: handleRequest,
    [events.removeListSucceeded]: handleSuccess,
    [events.removeListFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
